export const ADA = 'ADA';
export const FDI = 'FDI';


export default {
  ADA,
  FDI,
};
